import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import styles from './Input.module.css';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, leftIcon, rightIcon, className, ...rest },
  ref
) {
  const inputClass = [
    styles.input,
    leftIcon ? styles['with-left'] : null,
    rightIcon ? styles['with-right'] : null,
    invalid ? styles.invalid : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (!leftIcon && !rightIcon) {
    return <input ref={ref} className={inputClass} aria-invalid={invalid || undefined} {...rest} />;
  }

  return (
    <span className={styles.wrapper}>
      {leftIcon ? <span className={styles['icon-left']}>{leftIcon}</span> : null}
      <input ref={ref} className={inputClass} aria-invalid={invalid || undefined} {...rest} />
      {rightIcon ? <span className={styles['icon-right']}>{rightIcon}</span> : null}
    </span>
  );
});
